export enum Handler {
  progress,
  startClip,
  endClip,
}
